import { filter, remplazarPorTildeASinTilde } from "../../helpers/Buscador";
import { fetchConToken } from "../../helpers/fetch";
import { handleErrorApi } from "../../helpers/randoms";
import ComprasService from "../../services/ComprasService";
import { types } from "../../types/types";
import { startAlerta } from "../ui/alertas";
import { finishSpinner, startSpinner } from "../ui/spinner";

const baseUrl = process.env.REACT_APP_API_URL;;

export const setProveedor = (proveedor) => ({ type: types.proveedorAgregarSuccess, payload: proveedor });

export const consultarTipoProveedores = () => async (dispatch) => {
    dispatch(startSpinner())
    try{
        const response = await fetchConToken("Compras/Proveedores/ConsultarTiposProveedores", {}, "GET")
        const body = await response.json();
        let resultados = body;

        if(response.ok){
            dispatch({
                type: types.tipoProveedorSuccess,
                payload: resultados
            })
        }else{
            throw resultados
        }
    }catch(error){
        dispatch(finishSpinner())
        dispatch({type: types.tipoProveedorError})
        handleErrorApi(dispatch, error, "Error al traer los tipos de proveedor", "Ha ocurrido un error. Intente nuevamente")
    }
}

export const traerDatosContablesProveedor = (idProveedor) => async (dispatch) => {
    dispatch(startSpinner())
    try{
        const response = await fetchConToken(`Compras/DatosContables/${idProveedor}`, {}, "GET")
        const body = await response.json();
        let resultados = body;
        if(response.ok){dispatch({type: types.traerDatosContablesSuccess, payload: resultados})}
        else{throw resultados}
        dispatch(finishSpinner())
    }catch(error){
        dispatch(finishSpinner())
        dispatch({type: types.traerDatosContablesError})
        handleErrorApi(dispatch, error, "Error al traer los datos contables de proveedor", "Ha ocurrido un error. Intente nuevamente")
    }
}

export const traerDatosContactoProveedor = (idProveedor) => async (dispatch) => {
    dispatch(startSpinner)
    try{
        const response = await fetchConToken(`Compras/ProveedoresContactos/${idProveedor}`, {}, "GET")
        const body = await response.json();
        let resultados = body;
        if(response.ok){dispatch({type: types.datosContactosTraerSuccess, payload: resultados})}
        else{throw resultados}
        dispatch(finishSpinner())
    }catch(error){
        dispatch(finishSpinner())
        dispatch({type: types.datosContactosTraerError})
        handleErrorApi(dispatch, error, "Error al traer los contactos de proveedor", "Ha ocurrido un error. Intente nuevamente")

    }
}


export const crearNuevoDatosContacto = (formValues, handleClose) => async (dispatch) => {
    dispatch(startSpinner())
    try{
        
        const response = await fetchConToken(`Compras/ProveedoresContactos`, formValues, "POST")
        const body = await response.json();
        let resultados = body;

        if(response.ok){
            dispatch({
                type: types.guardarDatosContactoSuccess,
                payload: resultados
            })
            dispatch(finishSpinner())
            handleClose()
        }else{
            throw resultados
        }
    }catch(error){
        dispatch(finishSpinner())
        dispatch({type: types.guardarDatosContactoError})
        handleErrorApi(dispatch,error, "Error al guardar los nuevos datos de contacto")
    }
}

export const eliminarDatosContacto = (idProveedorContacto, handleClose) => async (dispatch) => {
    dispatch(startSpinner())
    try{
        const response = await fetchConToken(`Compras/ProveedoresContactos/${idProveedorContacto}`, {}, "DELETE")
        const body = await response.json();
        let resultados = body;

        if(response.ok){
            dispatch({
                type: types.guardarDatosContactoSuccess,
                payload: resultados
            })
            dispatch(finishSpinner())
            handleClose()
        }else{
            throw resultados
        }
    }catch(error){
        dispatch(finishSpinner())
        dispatch({type: types.guardarDatosContactoError})
        handleErrorApi(dispatch,error, "Error al eliminar los datos de contacto")
    }
}

export const guardarDatosContacto = (idProveedorContacto, formValues, handleClose) => async (dispatch) => {
    dispatch(startSpinner())
    try{
        const response = await fetchConToken(`Compras/ProveedoresContactos/${idProveedorContacto}`, formValues, "PUT")
        const body = await response.json();
        let resultados = body;

        if(response.ok){
            dispatch({
                type: types.guardarDatosContactoSuccess,
                payload: resultados
            })
            dispatch(finishSpinner())
            handleClose()
        }else{
            throw resultados
        }
    }catch(error){
        dispatch(finishSpinner())
        dispatch({type: types.guardarDatosContactoError})
        handleErrorApi(dispatch,error, "Error al guardar los datos de contacto")
    }
}

export const consultarRubrosProveedores = () => async (dispatch) => {
    dispatch(startSpinner())
    try{
        const response = await fetchConToken("Compras/Proveedores/ConsultarRubrosProveedores", {}, "GET")
        const body = await response.json();
        let resultados = body;

        if(response.ok){
            dispatch({
                type: types.rubrosProveedoresSuccess,
                payload: resultados
            })
        }else{
            throw resultados
        }
    }catch(error){
        dispatch(finishSpinner())
        dispatch({type: types.rubrosProveedoresError})
        handleErrorApi(dispatch, error, "Error al traer los rubros", "Ha ocurrido un error. Intente nuevamente")
    }
}

export const seleccionarAbmProveedor = (parametros = "") => async (dispatch) => {
    dispatch(startSpinner());
    try{
        const response = await ComprasService.BuscadorProveedores(parametros);
        const body = await response.json();
        let resultados = body;
        if(response.ok){
            if(parametros !== ""){
                resultados = resultados.filter(n => filter(remplazarPorTildeASinTilde(n.descripcion), remplazarPorTildeASinTilde(parametros)))
            }
            dispatch({
                type: types.proveedorAgregarSuccess,
                payload: resultados[0]
            })
            dispatch(finishSpinner());
        }else{
            throw resultados;
        }
    }catch(error){
        dispatch(finishSpinner());
        dispatch({type: types.proveedorAgregarError})
        handleErrorApi(dispatch, error, "Error al traer los proveedores", "Ha ocurrido un error. Intente nuevamente")
    }
};


export const guardarProveedor = (idProveedor, data, handleAfter) => async (dispatch) => {
    try{
        dispatch(startSpinner());
        let response;
        if(idProveedor){
            response = await ComprasService.ModificarProveedor(idProveedor,data);
        }else{
            response = await ComprasService.CrearProveedor(data);
        }

        const body = await response.json()

        if(response.ok){
            dispatch({
                type: types.proveedorAgregarSuccess,
                payload: body
            })
        }else {
            throw body
        }
    }catch (error){
        dispatch({type: types.proveedorAgregarError})
        dispatch(finishSpinner())
        handleErrorApi(dispatch, error, "Error al crear el proveedor", "Ha ocurrido un error intente nuevamente")
    }
};

export const eliminarProveedor = (idProveedor) => async (dispatch) => {
    try{
        dispatch(startSpinner());
        let response = await ComprasService.EliminarProveedor(idProveedor)
    
        const body = await response.json();

    if(response.ok){
        dispatch(startAlerta("Eliminación de proveedor realizada correctamente", 'success', 'Comando Exitoso'))
        dispatch(finishSpinner());
        // ¿Falta dispachar traerProveedores?
    } else {
        throw body
    }
    }catch (error) {
        dispatch(finishSpinner())
        handleErrorApi(dispatch, error, "Error al eliminar la categoria", "Ha ocurrido un error. Intente nuevamente")
    }
};

export const getDocumentacionProveedor = (idProveedor) => async (dispatch) => {
    dispatch(startSpinner())
    try{
        const response = await fetchConToken(`Compras/ProveedoresDocumentacion/${idProveedor}`,{},"GET")
        const body = await response.json()
        let resultados = body;

        if(response.ok){
            dispatch({
                type: types.traerDocumentacionProveedorSuccess,
                payload: resultados
            })
            dispatch(finishSpinner())
        }else{
            throw resultados;
        }

    }catch(error){
        dispatch(finishSpinner())
        dispatch({type: types.traerDocumentacionProveedorError})
        handleErrorApi(dispatch, error, 'Ha ocurrido un error al obtener la documentacion', 'Intente nuevamente')
    }
};


export const setDocumentacionProveedor = (file, idProveedor) => async (dispatch) => {
    try {
        dispatch(startSpinner());
        
        const formData = new FormData();
        formData.append("files", file);
        const token =
            localStorage.getItem("token") || sessionStorage.getItem("token") || "";
        let httpHeaders;
        if (token) {
            httpHeaders = {
                Authorization: `Bearer ${token}`,
            };
        }
        const response = await fetch(
            `${baseUrl}/Compras/ProveedoresDocumentacion/${idProveedor}`,
            {
                method: "POST",
                body: formData,
                headers: httpHeaders,
            }
        );
        const body = await response.json(); 
        if(response.ok){
            dispatch(getDocumentacionProveedor(idProveedor));
            dispatch(finishSpinner());
            dispatch(
                startAlerta(
                  "Datos Guardados Exitosamente",
                  "success",
                  "Comando Exitoso"
                )
              );
        }else{
            throw body; 
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(
          dispatch,
          error,
          "Error al guardar el documento.",
          "Ha ocurrido un error. Intente nuevamente."
        );
    }
}

export const eliminarDocumentacionProveedor = (idDocumentacionProveedorSelec) => async (dispatch, getState) => {
    dispatch(startSpinner())
    try{
        
        const response = await fetchConToken(`Compras/ProveedoresDocumentacion/${idDocumentacionProveedorSelec}`, {}, 'DELETE');
        const body = response.json();
        if (response.ok) {
            dispatch(finishSpinner());
            dispatch(
              startAlerta(
                "Documento Eliminado Exitosamente",
                "success",
                "Comando Exitoso"
              )
            );
          } else {
            throw body;
          }
    }catch (error){
        dispatch(finishSpinner());
        handleErrorApi(
        dispatch,
        error,
        "Error al guardar el documento.",
        "Ha ocurrido un error. Intente nuevamente."
      );
    }
}

export const desSeleccionarProveedor = ()  => {
    return{type: types.desSeleccionarProveedorInfo}
};

export const guardarInformacionProveedor = (data) => async (dispatch) => {
    dispatch(startSpinner())
    try{
        
        let response = null;
        if(data.idProveedor === null){
            response = await fetchConToken(`Compras/Proveedores/`, data, 'POST')
        }else {
            response = await fetchConToken(`Compras/Proveedores/${data.idProveedor}`, data, 'PUT')
        }
        const body = await response.json();
        if(response.ok){
            dispatch({
                type: types.proveedorGuardarInformacion,
                payload: data.idProveedor === null ? body : data
            })
            dispatch(finishSpinner())
            dispatch(startAlerta("Datos guardados correctamente", "success"))
        }else {
            throw body
        }
    }catch(error){
        dispatch(finishSpinner())
        handleErrorApi(dispatch, error, "Error al guardar la informacion del proveedor", "Ha ocurrido un error. Intente nuevamente")
    }
}

export const guardarInformacionContableProveedor = (idProveedor, data) => async (dispatch) => {
    dispatch(startSpinner())
    try{
        let response = null;
        if(data.idProveedor === null){
            response = await fetchConToken(`Compras/DatosContables/`, data, 'POST')
        }else {
            response = await fetchConToken(`Compras/DatosContables/${data.idProveedor}`, data, 'PUT')
        }
        const body = await response.json();
        if(response.ok){
            dispatch({
                type: types.proveedorGuardarDatosContables,
                payload: data.idProveedor === null ? body : data
            })
            dispatch(finishSpinner())
            dispatch(startAlerta("Datos guardados correctamente", "success"))
        }else {
            throw body
        }
    }catch(error){
        dispatch(finishSpinner())
        handleErrorApi(dispatch, error, "Error al guardar la informacion contable del proveedor", "Ha ocurrido un error. Intente nuevamente")
    }
}